import { render } from "./level.vue?vue&type=template&id=beb75052&scoped=true&ts=true"
import script from "./level.vue?vue&type=script&lang=ts"
export * from "./level.vue?vue&type=script&lang=ts"

import "./level.vue?vue&type=style&index=0&id=beb75052&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb75052"]])

export default __exports__